import React, { useState, useEffect } from 'react';
import { withNavbar } from './Navbar';
import { withRouterProps } from '../../common/withRouterProps';
import { makeStyles } from "@mui/styles";
import Typography from '@mui/material/Typography';
import { Grid, Tab, Tabs } from '@mui/material';
import { horizontalTabStyles, verticalTabStyles } from './sharedStyles';
import {
    AutoCloseSettingsTab,
    AppScopeTab,
    Catalog,
    Settings,
    CreateDSAR,
    EscalationFrequency,
    EscalationSettingsTab,
    FtpJiraSettings,
    RequestReviewSetting,
    ResponseReviewSetting,
    RoleConfig,
    Upstreams
} from './admin/index';
// import { styled } from '@mui/material/styles';


const useStyles = makeStyles(() => ({
    homePageWrapper: {
        fontSize: '0.8rem',
        height: "100%",
        // margin: "15px"
    },
    adminTabWrapper: {
        background: '#fff',
        height: "100%"
    },
    headerTitle: {
        fontSize: '1.2rem',
        fontWeight: 800,
        color: '#1e3a5f',
        letterSpacing: '1.5px',
        textTransform: 'uppercase',
        padding: '0px 0 10px 16px',
        margin: 0,
        borderBottom: '2px solid #267db7',
        marginBottom: '30px',
        display: 'flex',
        alignItems: 'baseline',
        gap: '12px',
        background: 'linear-gradient(90deg, #1e3a5f, #267db7)',
        WebkitBackgroundClip: 'text',
        WebkitTextFillColor: 'transparent',
    },
    headerSeparator: {
        WebkitTextFillColor: '#1e3a5f',
        fontWeight: 400,
        opacity: 0.5,
    },
    headerSubTitle: {
        fontWeight: 600,
        fontSize: '1rem',
    },
    verticalTabGridItem: {
        maxWidth: '200px',
        background: '#f5f7fa',
        borderRight: '1px solid #e2e8f0',
        borderRadius: '10px 0 0 10px',
        padding: '10px 0',
    },
    verticalTabGridContent: {
        maxWidth: 'calc( 100% - 180px)',
        overflow: 'hidden',
        background: '#fff',
        padding: '15px',
        '& .scopeHeader': {
            display: 'none',
        },
        '& > div > .header, & > div > div > .header': {
            display: 'none',
        },
    },
    ...verticalTabStyles,
    appsScopeWrapper: {
        ...horizontalTabStyles.tabWrapper,
        '& .scopeHeader': {
            padding: '10px 20px',
            fontSize: '1rem',
            fontWeight: 'bold',
            '& a': {
                color: "#212529"
            }
        },
    }
}));
// TabHistoryPaths Variable Holds all the tab paths available in the Admin Screen
const TabHistoryPaths = [
    "appsscope",
    "autoclosesetting",
    "contacts",
    "createdsr",
    "escalationfrequency",
    "escalationsetting",
    "ftpjirasettings",
    "requestreviewsettings",
    "responsereviewsettings",
    "roleconfig",
    "systemsettings",
    "upstreams"
];

const TabLabels = [
    "Apps Scope",
    "Auto Close Settings",
    "Contacts",
    "Create DSAR",
    "Escalation Frequency",
    "Escalation Settings",
    "FTP/JIRA Settings",
    "Request Review",
    "Response Review",
    "Role Config",
    "System Settings",
    "Upstreams"
];

function Admin(props) {
    const classes = useStyles();
    const [verticalTab, setVerticalTab] = useState(0);
    const { routerProps } = props
    const { history, match } = routerProps;
    useEffect(() => {
        if (match?.params?.page) {
            setVerticalTab(TabHistoryPaths.indexOf(match?.params?.page));
        }
  // eslint-disable-next-line react-hooks/exhaustive-deps
},[match])
    const activeTabName = TabHistoryPaths[verticalTab];
    return (
        <div className={`${classes.homePageWrapper}`}>
            <Grid container className={classes.adminTabWrapper}>
                <Grid item xs className={classes.verticalTabGridItem}>
                    <div className={classes.verticalTabWrapper}>
                        <Tabs
                            orientation="vertical"
                            variant="scrollable"
                            value={verticalTab}
                            onChange={(_event, newValue) => {
                                setVerticalTab(newValue);
                                const path = TabHistoryPaths[newValue];
                                history.push(`/admin/${path}`)
                            }}
                            aria-label="Vertical tabs"
                        >
                            <Tab label="Apps Scope" />
                            <Tab label="Auto Close Settings" />
                            <Tab label="Contacts" />
                            <Tab label="Create DSAR" />
                            <Tab label="Escalation Frequency" />
                            <Tab label="Escalation Settings" />
                            <Tab label="FTP/JIRA Settings" />
                            <Tab label="Request Review" />
                            <Tab label="Response Review" />
                            <Tab label="Role Config" />
                            <Tab label="System Settings" />
                            <Tab label="Upstreams" />
                        </Tabs>
                    </div>

                </Grid>
                <Grid item xs className={classes.verticalTabGridContent}>
                    <Typography variant="h6" className={classes.headerTitle}>
                        Admin Activities
                        <span className={classes.headerSeparator}>|</span>
                        <span className={classes.headerSubTitle}>{TabLabels[verticalTab]}</span>
                    </Typography>
                    {activeTabName === "appsscope" && (
                        <div className={classes.appsScopeWrapper}>
                            <AppScopeTab
                                active={match?.params?.tab}
                            />

                        </div>
                    )}
                    {activeTabName === "escalationfrequency" && (
                        <div className={classes.appsScopeWrapper}>
                            <EscalationFrequency
                                active={match?.params?.tab}
                            />
                        </div>
                    )}
                    {activeTabName === "escalationsetting" && (
                        <div className={classes.appsScopeWrapper}>
                            <EscalationSettingsTab
                                active={match?.params?.tab}
                            />
                        </div>
                    )}
                    {activeTabName === "ftpjirasettings" && (
                        <div className={classes.appsScopeWrapper}>
                            <FtpJiraSettings active={match?.params?.tab} />
                        </div>
                    )}
                    {activeTabName === "autoclosesetting" && (
                        <div className={classes.appsScopeWrapper}>
                            <AutoCloseSettingsTab
                                active={match?.params?.tab}
                            />
                        </div>
                    )}
                    {activeTabName === "systemsettings" && (
                        <div className={classes.appsScopeWrapper}>
                            <Settings active={match?.params?.tab} />
                        </div>
                    )}
                    {activeTabName === "contacts" && (
                        <div className={classes.appsScopeWrapper}>
                            <Catalog active={match?.params?.tab} />
                        </div>
                    )}
                    {activeTabName === "createdsr" && (
                        <div className={classes.appsScopeWrapper}>
                            <CreateDSAR />
                        </div>
                    )}
                    {activeTabName === "requestreviewsettings" && (
                        <div className={classes.appsScopeWrapper}>
                            <RequestReviewSetting
                                active={match?.params?.tab} />
                        </div>
                    )}
                    {activeTabName === "responsereviewsettings" && (
                        <div className={classes.appsScopeWrapper}>
                            <ResponseReviewSetting
                                active={match?.params?.tab}
                            />
                        </div>
                    )}
                    {activeTabName === "roleconfig" && (
                        <div className={classes.appsScopeWrapper}>
                            <RoleConfig />
                        </div>
                    )}
                    {activeTabName === "upstreams" && (
                        <div className={classes.appsScopeWrapper}>
                            <Upstreams />
                        </div>
                    )}
                    {verticalTab !== 0 && (
                        <div>

                        </div>
                    )}

                </Grid>
            </Grid>
        </div>
    );
}

export default withNavbar(withRouterProps(Admin), 4);
